var $ = require("jquery");
var Sticky = require('sticky-js');
var screenWidth = jQuery(window).width();
if (screenWidth >= 800) {
  var quicklinksSticky = new Sticky('.js-sticky');
}


jQuery('a[href*="#"]:not([href="#"])').click(function() {
    var offset = -200; // <-- change the value here
    if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
        var target = jQuery(this.hash);
        target = target.length ? target : jQuery('[name=' + this.hash.slice(1) +']');
        if (target.length) {
            jQuery('html, body').animate({
                scrollTop: target.offset().top + offset
            }, 1000);
            return false;
        }
    }
});


